import React, { useState } from 'react'
import PropTypes from 'prop-types'
import _, { isEmpty } from 'lodash'
import { Alert, Button, Col, Form, Icon, Input, Modal, Radio, Row, Upload } from 'antd'
import { FormItem } from '../../../../styles/shared.style'
import { ButtonEx } from '../../../../styles/button.style'
import { useDeepEffect } from '../../../../utils/hooks'
import { APP_CONFIG_META } from '../../../../utils/constants'

const AppConfigForm = (props) => {
  const { visible, onOk, onCancel, formData, form } = props
  const { getFieldDecorator, validateFields, setFieldsValue } = form

  useDeepEffect(() => {
    if (!isEmpty(formData)) {
      setFieldsValue({
        value: formData.value
      })
    }

    return () => {
      form.resetFields()
    }
  }, [formData])

  function onSubmit(e) {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        const data = {
          value: values.value
        }
        if (!_.isEmpty(formData)) {
          data.id = formData.id
        }
        onOk(data)
      }
    })
  }
  const meta = APP_CONFIG_META[formData && formData.name] || null

  return (
    <Modal
      title={meta ? `แก้ไข${meta.label}` : 'Update App Config Value'}
      visible={visible}
      footer={null}
      onCancel={onCancel}>
      <Form form={form} onSubmit={onSubmit} layout="vertical">
        {meta && (
          <Alert
            type="info"
            showIcon
            style={{ marginBottom: 16 }}
            message={meta.hint}
          />
        )}
        <Form.Item
          label={meta ? `${meta.label} (${meta.unit})` : 'Value'}>
          {getFieldDecorator(`value`, {
            rules: [
              {
                required: true,
                message: 'กรุณากรอก'
              },
              // ค่าพวกนี้ถูกอ่านเป็นตัวเลขในโค้ด กรอกตัวอักษรไปจะพังตอน
              // แปลงค่า ซึ่งเป็นความผิดพลาดที่มองไม่เห็นจนกว่าผู้ใช้จะเจอเอง
              {
                validator: (rule, value, callback) => {
                  if (!meta || !meta.integer) return callback()

                  if (!/^\d+$/.test(String(value || '').trim())) {
                    return callback('กรอกเป็นตัวเลขจำนวนเต็มเท่านั้น')
                  }
                  if (!meta.allowZero && Number(value) <= 0) {
                    return callback('ต้องมากกว่า 0')
                  }
                  return callback()
                }
              }
            ]
          })(<Input name="value" addonAfter={meta ? meta.unit : null} />)}
        </Form.Item>
        <Row type="flex" gutter={8} justify="end">
          <Col>
            <Button onClick={() => onCancel()}>ยกเลิก</Button>
          </Col>
          <Col>
            <ButtonEx color="#6ebf4b" type="primary" htmlType="submit">
              บันทึก
            </ButtonEx>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

const WrappedAppConfigForm = Form.create({ name: 'AppConfigForm' })(
  AppConfigForm
)
export default WrappedAppConfigForm
